import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentUtilService } from '../../common/payment/services';
import { UtilService } from 'src/app/shared/services';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ThankyouSuccessHeadModule } from '../../common/thankyou-success-head/thankyou-success-head.module';
import { PaymentOtdModule } from '../../common/payment-otd/payment-otd.module';
import { BillPayPitchComponent } from 'src/app/core/bill-pay-pitch/bill-pay-pitch.component';

@Component({
  selector: 'app-thankyou-page-tip',
  standalone: true,
  imports: [CommonModule, SharedModule, ThankyouSuccessHeadModule, PaymentOtdModule, BillPayPitchComponent],
  templateUrl: './thankyou-page-tip.component.html',
  styleUrls: ['./thankyou-page-tip.component.scss']
})
export class ThankyouPageTipComponent implements OnInit {

  @Input() config;
  isMobile: boolean = false;
  constructor(
    public utils: UtilService,
    private router: Router,
    private paymentService: PaymentUtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.utils?.isMobile();
    if (this.config?.order || this.config.currency) {
      this.paymentService.paymentCurrency.next(this.config?.order?.iso_currency || this.config.currency);
    }
    this.paymentService.initaiteQr = true;
  }

  // launchHubble(token){
  //   this.utils?.launchHubble(token);
  // }

  redirect() {
    this.router.navigate(['/crowdfunding/fundraisers']);
  }

}
